const windowGlobal = typeof window !== 'undefined' && window

export default windowGlobal
